"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Levels = exports.createLogger = exports.getLogger = void 0;
var logger_types_1 = require("./logger.types");
var getLogger = function (category) {
    var log = {};
    logger_types_1.levels.forEach(function (level) {
        log[level] = function (msg, metadata) {
            if (metadata === void 0) { metadata = {}; }
            if (level === 'error') {
                console.error(level, msg, __assign({ category: category }, metadata));
            }
            else {
                console.log(level, msg, __assign({ category: category }, metadata));
            }
        };
    });
    return log;
};
exports.getLogger = getLogger;
exports.createLogger = exports.getLogger;
exports.Levels = {
    info: 'info',
    debug: 'debug',
    warn: 'warn',
    error: 'error',
    trace: 'trace',
};
